import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastoreProfileCategoriesModule,
  DatastoreSkillsModule,
} from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { UserProfileHireMeActionStateModule } from 'app/user-profile/user-profile-hire-me-action-state/user-profile-hire-me-action-state.module';
import { ArticleItemComponent } from './user-portfolio-detail-items/article-item/article-item.component';
import { AudioItemComponent } from './user-portfolio-detail-items/audio-item/audio-item.component';
import { CodeItemComponent } from './user-portfolio-detail-items/code-item/code-item.component';
import { OtherItemComponent } from './user-portfolio-detail-items/other-item/other-item.component';
import { PictureItemComponent } from './user-portfolio-detail-items/picture-item/picture-item.component';
import { VideoItemComponent } from './user-portfolio-detail-items/video-item/video-item.component';
import { UserPortfolioItemHeadingComponent } from './user-portfolio-item-heading/user-portfolio-item-heading.component';
import { UserPortfolioItemOverlayComponent } from './user-portfolio-item-overlay.component';
import { UserPortfolioItemSkillsComponent } from './user-portfolio-item-skills/user-portfolio-item-skills.component';
import { UserPortfolioShareItemComponent } from './user-portfolio-share-item/user-portfolio-share-item.component';
import { UserPortfolioUserDetailsComponent } from './user-portfolio-user-details/user-portfolio-user-details.component';
import { UserPortfolioUserReputationComponent } from './user-portfolio-user-reputation/user-portfolio-user-reputation.component';

@NgModule({
  imports: [
    CommonModule,
    UiModule,
    DatastoreProfileCategoriesModule,
    DatastoreSkillsModule,
    UserProfileHireMeActionStateModule,
    TrackingModule,
  ],
  declarations: [
    UserPortfolioItemOverlayComponent,
    UserPortfolioItemSkillsComponent,
    UserPortfolioItemHeadingComponent,
    UserPortfolioUserDetailsComponent,
    UserPortfolioUserReputationComponent,
    UserPortfolioShareItemComponent,
    ArticleItemComponent,
    AudioItemComponent,
    CodeItemComponent,
    PictureItemComponent,
    VideoItemComponent,
    OtherItemComponent,
  ],
  entryComponents: [UserPortfolioItemOverlayComponent],
})
export class UserPortfolioItemOverlayModule {}
